import { WarningAltFilled } from "@carbon/icons-react";
import i18next from "../../../i18n";

type AlertBannerProps = {
  title: string;
  comments?: string;
  icon?: React.ReactNode;
};

const AlertBanner = ({ title, comments, icon }: AlertBannerProps) => {
  return (
    <div className="col-span-3 p-2 mb-2 rounded border border-red-600 bg-red-200">
      <div className="flex items-center gap-1">
        {icon ? (
          icon
        ) : (
          <WarningAltFilled size={16} className="text-red-600" />
        )}
        <p className="text-xxs font-bold uppercase">{i18next.t(title)}</p>
      </div>
      {comments && <p className="text-xxs mt-4">{comments}</p>}
    </div>
  );
};

export default AlertBanner;
